import {Directive, ElementRef, EventEmitter, Output} from '@angular/core';
import {NgModel} from '@angular/forms';

@Directive({
    selector: `[ngModel][ngModelWc]`,
    providers: [NgModel]
})
export class NgModelWc {

    @Output() ngModelChange:EventEmitter<any> = new EventEmitter();

    constructor(private element: ElementRef, private ngModel: NgModel) {}

    ngOnInit() {
        let that = this;

        that.ngModel.valueChanges.subscribe(function (value) {
            console.log("value change");
            that.element.nativeElement.value = value;
        });

        that.element.nativeElement.addEventListener("change",function () {
            console.log("Adding ngModel event listener");
            that.ngModelChange.emit(that.element.nativeElement.value);
        });
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/ngmodel-for-wc.ts